<template>
  <div id="mainContent" class="scene-detail content">
    <div class="flex_row">
      <!-- <el-select v-model="selectDayOption" placeholder="请选择">
        <el-option v-for="item in selectDayOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled" />
      </el-select> -->
      <el-date-picker v-model="selectDayWeekReport" type="daterange" :range-separator="$t('AllDevices.to')"
        :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')"
        @change="changeSearchWeekReport" />

      <el-radio-group v-model="activeTab" @change="handleClick" style="margin-left: 10px;">
        <el-radio-button label="prevDay">{{$t('yhubReport.yesterday')}}</el-radio-button>
        <el-radio-button label="prevWeek">{{$t('yhubReport.aWeek')}}</el-radio-button>
        <el-radio-button label="prevMonth">{{$t('yhubReport.aMonth')}}</el-radio-button>
      </el-radio-group>

    </div>
    <br>

    <!-- <img v-show="isPrint" src="@/assets/images/gpd_logo.png" style="margin: 5px 0 0 10px;height:30px;"> -->
    <!-- 基本信息 -->
    <el-row>
      <div class="headTitle weekReportHead">
        <div class="headBr" />
        <div class="headContent">
          <p>
            <span>{{ basicinfo.deviceName }}</span>
            ({{ basicinfo.deviceSn }})
          </p>
          <p> {{ basicinfo.startTime }}-{{ basicinfo.endTime }}</p>
        </div>
        <div class="headBr" />
      </div>
    </el-row>
    <el-row>
      <div class="headTitle headInfo">
        <span class="fontStyle2" style="margin-left: 0;" />
        <span class="fontStyle1">{{ $t('report.TotalCharged') }}：{{ basicinfo.chargedah }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('report.TotalDischarged') }}：{{ basicinfo.usedah }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t('report.newWarnings') }}：{{ basicinfo.warningAccount }}</span>

        <div v-show="!isShowLogo&&$store.state.userInfo.guestFlag!=true" class="downBtn" @click="downPDF()">
          {{ $t("report.downWeekReport") }}</div>

      </div>
    </el-row>

    <!-- Charged and Discharged Records -->
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:20px;background:white;position:relative;">
        <div style="margin-bottom: 20px;">
          <p class="blockTitleP" style="display:inline-block;">{{ $t("yhubReport.chargeAndDischargeRecords") }}</p>
          <i v-if="!isPrint" class="el-icon-question" :class="$store.state.language"
            @mouseout="mouseoutQuestion(0,'dischargePop')" @mouseover="mouseoverQuestion(0,'dischargePop')" />
          <div class="dischargePop">
            <p>{{ $t('yhubReport.dischargeInfo') }}</p>
          </div>
        </div>
        <!-- 柱状图 -->
        <div style="width:100%;position:relative;" class="columnLineWarp">
          <div id="chart2" class="chart" style="height:500px;width:100%;" />
          <img id="chart3" style="width:100%;height:500px;display:none;">
          
          <p v-show="columnLineNoData"
            style="text-align: center;line-height: 30px;top: 230px;position: absolute;width: 100%;">
            {{ $t("yhubReport.Nodata") }}
          </p>
          
        </div>
        <!-- Charged Records -->
        <div class="blockTitleP">
          {{ $t("yhubReport.Records") }}
          <el-button v-if="!isPrint" :title="$t('titles.toInfoDetail')" type="primary" icon="el-icon-data-line"
            @click="readMore(null)" />
        </div>

        <!-- 由于打印时，el-table的宽度超出，无法设置宽度，因此改为原生的写法 -->
        <!-- <div :class="{'tableOverflow':!isPrint}" v-if="false">
          <table border="1"
            style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border: none;border-collapse:collapse;">
            <thead style="line-height: 40px;">
              <th>{{$t('yhubReport.index')}}</th>
              <th>{{ $t('yhubReport.StartingTime') }}</th>
              <th>{{ $t('yhubReport.StartSOC') }}</th>
              <th>{{ $t('yhubReport.EndTime') }}</th>
              <th>{{ $t('yhubReport.EndSOC') }}</th>
              <th>{{ $t('yhubReport.ah') }}</th>
              <th>KWH</th>
              <th>{{ $t('yhubReport.StartTemp') }}</th>
              <th>{{ $t('yhubReport.EndTemp') }}</th>
              <th>{{ $t('yhubReport.averageTemp') }}</th>
              <th>{{ $t('yhubReport.MinVoltage') }}</th>
              <th>{{ $t('yhubReport.MaxVoltage') }}</th>
              <th>{{ $t('yhubReport.ChargType') }}</th>
              <th>{{ $t('yhubReport.Duration') }}</th>
              <th>{{ $t('AllDevices.Status') }}</th>
              <th v-if="!isPrint">{{ $t('yhubReport.Charts') }}</th>
            </thead>
            <tbody style="color: #324057;" class="columnTable">
              <tr v-for="(item,index) in chargedRecordsList" :key="index">
                <td>{{item.cycles}}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.startSoc }}</td>
                <td>{{ item.endTime }}</td>
                <td>{{ item.endSoc }}</td>
                <td>{{ item.energy }}</td>
                <td>{{ item.wh }}</td>
                <td>{{ item.startTemp }}</td>
                <td>{{ item.endTemp }}</td>
                <td>{{ item.avgTemp }}</td>
                <td>{{ item.minVoltage }}</td>
                <td>{{ item.maxVoltage }}</td>
                <td>{{ item.chargingTypeZh }}</td>
                <td>{{ item.chargedTime }}</td>
                <td v-if="item.isChargeing">{{ $t('basicinfo.Charged') }}</td>
                <td v-if="!item.isChargeing">{{ $t('basicinfo.DisCharged') }}</td>
                <td v-if="!isPrint">
                  <div style="text-align: center;">
                    <el-button type="primary" size="mini" class="el-icon-data-line" @click="readMore(item)" />

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->

        <!-- <div v-if="chargedRecordsList.length==0" class="noDataDiv">{{ $t('yhubReport.Nodata') }}</div> -->

        <el-table :data="chargedRecordsList" border style="width: 100%" fit class="myTable chargedRecordTable"
          :span-method="objectSpanMethod">
          <el-table-column :label="$t('yhubReport.index')" prop="" align="center">
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row.cycles }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="num" prop="num" align="center" />
          <el-table-column label="myCycleNum" prop="myCycleNum" align="center" />
          <el-table-column label="chargingNum" prop="chargingNum" align="center" /> -->
          <el-table-column :label="$t('yhubReport.StartingTime')" prop="startTime" align="center" />
          <el-table-column :label="$t('yhubReport.StartSOC')" prop="startSoc" align="center" />
          <el-table-column :label="$t('yhubReport.EndTime')" prop="endTime" align="center" />
          <el-table-column :label="$t('yhubReport.EndSOC')" prop="endSoc" align="center" />
          <el-table-column :label="$t('yhubReport.ah')" prop="energy" align="center" />
          <el-table-column label="KWH" prop="wh" align="center" />
          <el-table-column :label="$t('yhubReport.StartTemp')" prop="startTemp" align="center" />
          <el-table-column :label="$t('yhubReport.EndTemp')" prop="endTemp" align="center" />
          <el-table-column :label="$t('yhubReport.averageTemp')" prop="avgTemp" align="center" />
          <el-table-column :label="$t('yhubReport.MinVoltage')" prop="minVoltage" align="center" />
          <el-table-column :label="$t('yhubReport.MaxVoltage')" prop="maxVoltage" align="center" />
          <el-table-column :label="$t('yhubReport.ChargType')" prop="chargingTypeZh" align="center" />
          <el-table-column :label="$t('yhubReport.Duration')" prop="chargedTime" align="center" />
          <el-table-column :label="$t('AllDevices.Status')" prop="chargeDisStatu" align="center">
            <template slot-scope="scope">
              <div>
                <p v-if="scope.row.isChargeing">{{ $t('basicinfo.Charged') }}</p>
                <p v-if="!scope.row.isChargeing">{{ $t('basicinfo.DisCharged') }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('yhubReport.Charts')" prop="action" align="center">
            <template slot-scope="scope">
              <div>
                <el-button type="primary" size="mini" class="el-icon-data-line" @click="readMore(scope.row)" />
                <!-- <el-button v-if="!scope.row.isChargeing&&$store.state.isAdmin" type="primary" size="mini" class=""
                  @click="openCountSohPop(scope.row)">SOH</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>

      </el-col>
    </el-row>

    <!-- Warning -->
    <el-row v-if="type=='Yhub'" :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;">{{ $t('yhubReport.WarningMessage') }}</p>
        <!-- <el-table v-if="!isPrint" stripe :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}" border>
          <el-table-column prop="createTime" :label="$t('warningPage.CreatedAt')" align="center" min-width="10%" />
          <el-table-column prop="message" :label="$t('warningPage.Content')" min-width="25%" />
          <el-table-column prop="status" :label="$t('AllDevices.Status')" align="center" min-width="10%" />
          <el-table-column prop="updateTime" :label="$t('warningPage.SovledAt')" sortable align="center" min-width="10%" />
          <el-table-column prop="remark" :label="$t('warningPage.Remark')" align="center" min-width="25%" />
        </el-table> -->
        <!-- 由于打印时，el-table的宽度超出，无法设置宽度，因此改为原生的写法 -->
        <table border="1"
          style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border: none;border-collapse:collapse;">
          <thead style="line-height: 40px;">
            <th>{{ $t('warningPage.CreatedAt') }}</th>
            <th>{{ $t('warningPage.Content') }}</th>
            <th>{{ $t('AllDevices.Status') }}</th>
            <th>{{ $t('warningPage.SovledAt') }}</th>
            <th>{{ $t('warningPage.Remark') }}</th>
          </thead>
          <tbody style="color: #324057;" class="columnTable">
            <tr v-for="(item,index) in tableData" :key="index">
              <td>{{ item.createTime }}</td>
              <td>{{ item.message }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.updateTime }}</td>
              <td>{{ item.remark }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="tableData.length==0" class="noDataDiv">{{ $t('yhubReport.Nodata') }}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0;">
        <!-- 列表模块————分页 -->
        <div style="background-color: white;width: 100%;border-radius: 0;padding: 0 0 20px 20px;">
          <div class="pagination-container">
            <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
              :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
              layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
              @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- Devices Summary -->
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;">{{ $t('yhubReport.Dailystatistics') }}</p>
        <div class="pane_content overhiden SummaryWarp">
          <div class="pane_content"
            style="border: 1px solid #F5F7FA;width:100%;margin-top:10px;margin-bottom:10px;position:relative;">
            <!-- <el-table border="" :data="odcDailyVoList" style='width:auto' fit class='myTable'>
            <el-table-column prop="monthDay" label="星期"> </el-table-column>
            <el-table-column prop="usedTime" label="使用时长"> </el-table-column>
            <el-table-column prop="workTime" label="工作时长"> </el-table-column>
            <el-table-column prop="usedRate" label="使用率"> </el-table-column>
            <el-table-column prop="usedAh" label="放电量"> </el-table-column>
            <el-table-column prop="charedAh" label="充电量"> </el-table-column>
            <el-table-column prop="minSoc" label="最低Soc"> </el-table-column>
            <el-table-column prop="minVoltage" label="最低电压"> </el-table-column>
            <el-table-column prop="maxTemprature" label="最高温度"> </el-table-column>
          </el-table> -->
            <div v-if="isShowWorkTimePop" class="WorkTimeWarp">
              <p>{{ $t('yhubReport.workTime') }}</p>
            </div>
            <div v-if="isShowUsedTimePop" class="usedTimeWarp">
              <p>{{ $t('yhubReport.usedTime') }}</p>
            </div>
            <table border="1"
              style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border: none;border-collapse:collapse;">
              <thead style="line-height: 40px;">
                <th>{{ $t('yhubReport.Date') }}</th>
                <th>{{ $t('yhubReport.WorkingHours') }}<i v-if="!isPrint" class="el-icon-question"
                    @mouseover="isShowWorkTimePop=true" @mouseout="isShowWorkTimePop=false" /></th>
                <th>{{ $t('yhubReport.UseTime') }}<i v-if="!isPrint" class="el-icon-question"
                    @mouseover="isShowUsedTimePop=true" @mouseout="isShowUsedTimePop=false" /></th>
                <th>{{ $t('yhubReport.Discharge') }}</th>
                <th>{{ $t('basicinfo.DisCharged') }}(kWh)</th>
                <th>{{ $t('yhubReport.ChargingTime') }}</th>
                <th>{{ $t('yhubReport.Charge') }}</th>
                <th>{{ $t('basicinfo.Charged') }}(kWh)</th>
                <th>{{ $t('yhubReport.MinimumSOC') }}</th>
                <th>{{ $t('yhubReport.MinimumVoltage') }}</th>
                <th>{{ $t('yhubReport.MaximumTemperature') }}</th>
              </thead>
              <tbody style="color: #324057;" class="columnTable">
                <tr v-for="(item,index) in devicesSummaryList" :key="index">
                  <td>{{ item.monthDay }}</td>
                  <td>{{ parseInt((item.workTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) }} h
                    {{ parseInt((item.workTime % (1000 * 60 * 60)) / (60* 1000)) }} min </td>
                  <td>{{ parseInt((item.usedTime% (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) }} h
                    {{ parseInt((item.usedTime% (1000 * 60 * 60)) / (60* 1000)) }} min </td>
                  <td>{{ (item.usedAh/100) |handleFloat }} Ah</td>
                  <td>{{ (item.usingWh/100000)|handleFloat }} kWh</td>
                  <td :title="item.chargeTime">
                    {{ parseInt((item.chargeTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) }} h
                    {{ parseInt((item.chargeTime % (1000 * 60 * 60)) / (60* 1000)) }} min </td>
                  <td>{{ (item.charedAh/100) |handleFloat }} Ah</td>
                  <td>{{ (item.chargingWh/100000)|handleFloat }} kWh</td>
                  <td>{{ Math.round(item.minSoc/100) }} %</td>
                  <td>{{ item.minVoltage/100 }} V</td>
                  <!-- <td>{{ Math.round(item.maxTemprature/100) }} ℃</td> -->
                  <td>{{ item.maxTempratureS }} {{ unit }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="devicesSummaryList.length==0" class="noDataDiv">{{ $t('yhubReport.Nodata') }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <el-table v-show="!isPrint" border="" :data="devicesSummaryList" :row-class-name="rowIndex"
          style="width: 100%;margin-top: 10px;">
          <el-table-column prop="monthDay" min-width="10%" align="center" :label="$t('yhubReport.Date')" />
          <el-table-column min-width="40%" prop="1" :label="$t('yhubReport.Charts')" align="center">
            <template scope="scope">
              <div>
                <div class="pieChartDiv">
                  <yhub-pie-chart class="myPieChartFirst" :series-data="scope.row.pieSeriesData1" :height="pieHeight"
                    :color-arr="colorArr1" />
                  <yhub-pie-chart class="myPieChartSecond" :series-data="scope.row.pieSeriesData2" :height="pieHeight"
                    :color-arr="colorArr2" style="display:none;" />
                </div>
                <div style="position: absolute;text-align: left;bottom: 20px;width:100%;">
                  <!-- 使用率、充放电比 -->
                  <button class="changePieBtn firstBtn active"
                    @click="changePieChart($event,1,scope.$index)">{{ $t("yhubReport.UsageRate") }}</button>
                  <button class="changePieBtn secondBtn"
                    @click="changePieChart($event,2,scope.$index)">{{ $t("yhubReport.Ratio") }}</button>
                  <div class="el-icon-question" style="font-size:20px;" @mouseover="mouseoverQuestion(scope.$index)"
                    @mouseout="mouseoutQuestion(scope.$index)" />
                  <!-- 选项卡处的问号弹窗 -->
                  <div class="questionPop">
                    <p v-if="$store.state.language=='en'||$store.state.language=='de'">{{ $t("yhubReport.Ratio") }} =
                      {{ $t("yhubReport.chargeDischargeRatio") }}</p>
                    <p>{{ $t('yhubReport.DischargeInfo') }}</p>
                    <p>{{ $t('yhubReport.ChargeInfo') }}</p>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="50%" prop="2" :label="$t('yhubReport.AHDistribution')" align="center">
            <template scope="scope">
              <yhubReportBarChart :height="pieHeight" :data-detail="scope.row.odcEventDailyVoList1" />
              <!-- <yhub-bar-chart prop="odcEventDailyVoList" :height="pieHeight" :data-detail="scope.row.odcEventDailyVoList" /> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" width="90%">
      <el-form ref="bindDeviceModel" label-position="right">
        <el-form-item>
          <!-- 日期选择器 -->
          <!-- <el-date-picker v-model="selectDay" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch" /> -->
          <el-date-picker v-model="popStartDate" type="datetime" size="mini" value-format="timestamp"
            :placeholder="$t('AllDevices.startDate')" :disabled="true" />
          <span>{{ $t('AllDevices.to') }}</span>
          <el-date-picker v-model="popEndDate" type="datetime" size="mini" value-format="timestamp"
            :placeholder="$t('AllDevices.endDate')" :disabled="true" />
          <el-button class="filter-item" type="primary" size="mini" icon="el-icon-search" @click="changeSearch" />
          <el-button v-if="$store.state.userInfo.guestFlag!=true" size="mini" type="primary" align="right"
            style="text-align: center;float:right;margin-right: 40px" @click="downLoadExcel">Download Raw CSV
          </el-button>
          <el-button v-if="type=='Yhub'&&$store.state.userInfo.guestFlag!=true" size="mini" type="primary" align="right"
            style="text-align: center;float:right;margin-right: 40px" @click="downLoadReportExcel"> Download Report
            CSV</el-button>
        </el-form-item>
      </el-form>
      <el-form ref="bindDeviceModel" v-loading="loading" label-position="right">
        <el-form-item>
          <div v-if="isShowNoData" class="noDataWarp">
            <div>{{ $t('yhubReport.Nodata') }}</div>
          </div>
          <yhubLineChart v-if="type=='Yhub'" :line-chart-data="yhubLineChartData" :is-show-half-v="isShowHalfV"
            :height="lineHeight" @legendselect="legendselect" />
          <lithiumLineChart v-if="type=='Lithium'" :line-chart-data="lithiumLineChartData" :height="lineHeight" />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 用逗号" , "作小数点分隔符 -->
    <el-dialog :close-on-click-modal="false" class="regionPop" :visible.sync="isShowRegionPop" width="60%"
      style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p class="regionP">{{ $t('yhubReport.UseComma') }} </p>
      <el-radio v-model="regionType" :label="2" @change="change">{{ $t('allDeviceDetail.Yes') }}</el-radio>
      <el-radio v-model="regionType" :label="1" @change="change">{{ $t('allDeviceDetail.no') }}</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowRegionPop = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
    <!-- 下载中 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowLoadingPop" width="60%"
      style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p>{{ $t('button.Downloading') }}</p>
    </el-dialog>
  </div>
</template>
<script>
import { findDeviceInfo, getHourReport, getOdc, getOdcBMS, getHourReportBMS, listChargingDischarging, listChargingDischargingBMS, listRecordData, getDynamicData } from '@/api/yhub'
import { listBMSRecor } from '@/api/allDevice'
import echarts from 'echarts'
import { getDateAndHour, getDateAndWeek } from '@/utils/updateTime.js'
import yhubPieChart from '@/components/yhubPieChart'
import yhubReportBarChart from '@/components/yhubReportBarChart'
// import columnLineChart from '@/components/columnLineChart'
import yhubLineChart from '@/components/lineChart'
import lithiumLineChart from '@/components/lineChartLithium'
import { thousandFn } from '@/utils/thousandFn.js'
import i18n from '@/i18n'
import { pagination } from '@/utils/init_table' // 分页
import { listWarningPushMsg2 } from '@/api/warning'
import { temChangeUnit, temChange, temUnit } from '@/utils/temChange.js'
// MQTT--------------start
import protobuf from 'protobufjs'
// const YhubRequest = yhubproto.lookup('framework.YhubRequest')

// MQTT--------------end
import apiproto from '@/proto/apiproto'
const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')

import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { handleFloat } from '@/utils'

export default {
  components: {
    yhubPieChart,
    yhubLineChart,
    lithiumLineChart,
    yhubReportBarChart
  },
  filters: {
    handleFloat
  },
  data () {
    this.protobuf
    return {
      basicinfo: {
        week: '',
        startTime: '',
        endTime: '',
        deviceName: '',
        sn: '',
        openIgnitionVol: '',
        workHourmeterVol: '',
        fullChargeTime: '',
        chargedah: '',
        usedah: '',
        warningAccount: ''
      },
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      weekReportInfo: {},
      param: {},
      chargedRecordsList: [],
      warningList: [],
      devicesSummaryList: [],
      devicesSummaryList1: [],
      pieHeight: '200px',
      colorArr1: ['#a9d252', '#ff8c23', '#019ad6'],
      colorArr2: ['#e2c31d', '#33cccc'],
      // columnLineHeight: '500px',
      // columnLineData: {},
      // columnLineN: [],
      columnLineNoData: false,
      msg: null, // MQTT
      dataSize: null,
      chargedAh: null,
      socData: [],
      jlcgImgBase64: null,
      isPrint: false,
      isShowPop: false,
      yhubLineChartData: {
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d7: [],
        d8: [],
        d9: [],
        d10: [],
        d11: [],
        a1: [],
        a2: [],
        a3: [],
        a32: [],
        a4: [],
        a5: [],
        a6: [],
        a7: []
      },
      isShowHalfV: 0,
      legendselectStr: [],
      lithiumLineChartData: {
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d7: [],
        d8: [],
        d9: [],
        d10: [],
        d11: [],
        a1: [],
        a2: [],
        a3: [],
        a4: [],
        a5: [],
        a6: []
      },
      lineHeight: '600px',
      popStartDate: '',
      popEndDate: '',
      weekReportStartTime: '',
      weekReportEndTime: '',
      popMcuId: null,
      popSn: null,
      row: {},
      chargedRecordArr: [],
      tableData: [], // 警告表格
      type: this.$route.query.type,
      loading: false,
      isShowLogo: false,
      printTime: null,
      isShowNoData: false,
      isShowWorkTimePop: false,
      isShowUsedTimePop: false,
      isShowLoadingPop: false,
      isShowRegionPop: false,
      regionType: 2,
      unit: '℃',
      activeTab: '',
      todayTimeE: new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000, // 今天23:59:59
      prevWeekS: new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, // 一周开始时间
      prevMonthS: new Date(new Date().setHours(0, 0, 0, 0)).setMonth(new Date().getMonth() - 1), // 一个月开始时间
      selectDayWeekReport: [] // 日期选择

    }
  },
  beforeRouteLeave (to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language (newValue, oldValue) {
      this.queryList()
      this.queryWarnings()
      setTimeout(() => {
        this.initChart2()
      }, 500)
    },
    devicesSummaryList1: {
      handler (newValue, oldValue) {
        this.devicesSummaryList1 = newValue // 把新值赋值给我们的属性数据
      },
      deep: true
    }
  },
  mounted () {
    this.unit = temUnit()
    setTimeout(() => {
      this.weekReportInfo = JSON.parse(sessionStorage.getItem('weekReportInfo'))
      if (this.weekReportInfo == null) {
        return
      }
      console.log(this.weekReportInfo)
      this.weekReportStartTime = this.popStartDate = this.weekReportInfo.startTime // 如：2020.12.14 0:0:0
      this.weekReportEndTime = this.popEndDate = this.weekReportInfo.endTime // 如：2020.12.20 23:59:59
      this.basicinfo.week = this.weekReportInfo.week
      this.basicinfo.deviceName = this.weekReportInfo.deviceName
      this.basicinfo.chargedah = this.weekReportInfo.chargedah
      this.basicinfo.usedah = this.weekReportInfo.usedah
      this.basicinfo.warningAccount = this.weekReportInfo.warningAccount
      this.basicinfo.deviceSn = this.$route.query.sn
      this.basicinfo.startTime = getDateAndHour(this.weekReportStartTime, 'noTime')
      this.basicinfo.endTime = getDateAndHour(this.weekReportEndTime, 'noTime')

      this.selectDayWeekReport = [this.basicinfo.startTime, this.basicinfo.endTime]
      if (this.weekReportInfo.week == null || this.weekReportInfo.week == -1) {
        this.showDynamicData()
      }

      this.queryList()
      this.queryWarnings()
      setTimeout(() => {
        this.initChart2()
      }, 500)
    }, 500)
    this.$nextTick(() => {
      var isShowDischargePopS = document.querySelectorAll('.dischargePop')
      isShowDischargePopS.forEach(v => {
        v.style.display = 'none'
      })
    })
  },
  created () {
  },
  methods: {
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex > 0 && this.chargedRecordsList[rowIndex - 1].cycles == this.chargedRecordsList[rowIndex].cycles) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          return {
            rowspan: row.num,
            colspan: 1
          }
        }
      }
      //  else if (columnIndex === 12) {
      //   return {
      //     rowspan: row.myCycleNum,
      //     colspan: 1
      //   }
      // }
    },
    mouseoverQuestion (index, key) {
      if (!key) document.querySelectorAll('.questionPop')[index].style.display = 'block'
      if (key && key == 'dischargePop') document.querySelectorAll('.dischargePop')[index].style.display = 'block'
    },
    mouseoutQuestion (index, key) {
      if (!key) document.querySelectorAll('.questionPop')[index].style.display = 'none'
      if (key && key == 'dischargePop') document.querySelectorAll('.dischargePop')[index].style.display = 'none'
    },
    handleClick () { // 点击时间选项卡
      if (this.activeTab == 'prevDay') {
        this.selectDayWeekReport = [new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000, this.todayTimeE - 24 * 60 * 60 * 1000]
      } else if (this.activeTab == 'prevWeek') {
        this.selectDayWeekReport = [this.prevWeekS, this.todayTimeE - 24 * 60 * 60 * 1000]
      } else if (this.activeTab == 'prevMonth') {
        this.selectDayWeekReport = [this.prevMonthS, this.todayTimeE - 24 * 60 * 60 * 1000]
      }
      this.weekReportStartTime = new Date(this.selectDayWeekReport[0]).getTime()
      this.weekReportEndTime = new Date(this.selectDayWeekReport[1]).getTime()
      console.log(this.weekReportStartTime, '--', this.weekReportEndTime)
      // TODO
      this.queryList()
      this.queryWarnings()
      setTimeout(() => {
        this.initChart2()
      }, 500)

      this.basicinfo.startTime = getDateAndHour(this.weekReportStartTime, 'noTime')
      this.basicinfo.endTime = getDateAndHour(this.weekReportEndTime, 'noTime')
      this.showDynamicData()
    },
    queryWarnings () {
      var param = {

        endDate: this.weekReportEndTime, //
        // startDate: new Date(getDateAndHour(new Date().getTime() - 30 * 24 * 60 * 60 * 1000, 'noTime')).getTime() - 8 * 60 * 60 * 1000, // 开始时间 2019-11-21 -> 时间戳
        startDate: this.weekReportStartTime, // 开始时间 2019-11-21 -> 时间戳
        key: this.$route.query.mcuId,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      listWarningPushMsg2(param).then(res => { // 警告信息列表数据
        if (res.resultCode === 1001) {
          if (!res.resultModel) { this.tableData = []; return }
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData = res.resultModel.list
          for (var i = this.tableData.length - 1; i >= 0; i--) {
            var v = this.tableData[i]
            v.createTime = getDateAndHour(v.createTime, 'noYear')
            // v.createTime = getDateAndHour(v.createTime, 'noYear')
            if (v.delFlag == 1) { v.updateTime = getDateAndHour(v.updateTime, 'noYear'); v.status = i18n.t('warningPage.Solevd') } else { v.updateTime = '--'; v.status = i18n.t('warningPage.Unsolved') }
            switch (v.msgType) {
              case 1: {
                if (v.triggerValue) v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
                v.message = i18n.t('warningInfo.batterySocLow1') + v.triggerValue + i18n.t(`warningInfo.batterySocLow2`); break
              }
              case 2: v.message = i18n.t('warningInfo.batteryWaterLow'); break
              case 4: {
                if (v.triggerValue) v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
                v.message = i18n.t('warningInfo.batteryTemHeight1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemHeight2'); break
              }
              case 5: { v.message = i18n.t('warningInfo.batteryCapacity1') + v.triggerValue + i18n.t('warningInfo.batteryCapacity2'); break }
              case 6: { v.message = i18n.t('warningInfo.batteryNoPosition'); break }
              case 7: { v.message = i18n.t('warningInfo.batteryVoltageLow1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageLow2'); break }
              case 8: { v.message = i18n.t('warningInfo.batteryTemLow1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemLow2'); break }
              case 9: { v.message = i18n.t('warningInfo.batteryTemAbnormal'); break }
              case 10: { v.message = i18n.t('warningInfo.batteryVoltageHeight1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageHeight2'); break }
              case 15: { v.message = i18n.t('warningInfo.HalfVWarn'); break }
              case 16: { v.message = i18n.t('warningInfo.offlineWarn').replace('$1', v.triggerValue); break }
              case 17: { v.message = i18n.t('warningInfo.linChargeOverWarn'); break }
              case 18: {
                if (v.triggerValue) { v.triggerValueZh = getDateAndHour(v.triggerValue, 'noTime') }
                v.message = i18n.t('warningInfo.overTiemTo').replace('$1', v.triggerValueZh)
                break
              }
              case 19: { v.message = i18n.t('warningInfo.overTiem'); break }
              case 20: { v.message = i18n.t('warningSet.chargeDisAbnormalWarn'); break }
              case 21: { v.message = i18n.t('warningInfo.unitVLowWarn'); break }
              default: this.tableData.splice(i, 1)
            }
          }
        }
      })
    },
    queryList () { // 获取基本数据和表格中的饼状图及柱状图数据
      this.param = {
        endDate: this.weekReportEndTime,
        mcuId: this.$route.query.mcuId,
        startDate: this.weekReportStartTime
      }
      if (this.type == 'Yhub') {
        this.getOdcYhub(this.param)
      } else if (this.type == 'Lithium') {
        this.getOdcLithium(this.param)
      }
      var param1 = {
        mcuId: this.$route.query.mcuId,
        myToken: this.$store.state.token
      }
      findDeviceInfo(param1).then(res => { // 基本信息
        // console.log(res.resultModel)
        this.isShowHalfV = res.resultModel.halfV
        this.basicinfo.openIgnitionVol = res.resultModel.openIgnitionVol
        this.basicinfo.workHourmeterVol = res.resultModel.workHourmeterVol
        this.basicinfo.fullChargeTime = res.resultModel.fullChargeTime
        this.getFullChargeStatu()// 判断充放电记录表格中的满充和临时充电
      })
    },
    showDynamicData () {
      this.basicinfo.chargedah = '--'
      this.basicinfo.usedah = '--'
      this.basicinfo.warningAccount = '--'
      console.log(this.basicinfo)
      var param1 = {
        mcuId: this.$route.query.mcuId,
        startTime: this.weekReportStartTime,
        endTime: this.weekReportEndTime,
        type: this.type == 'Lithium' ? 'e' : 'a'
      }
      getDynamicData(param1).then(res => { // 动态数据
        if (res.resultModel == null) {
          this.basicinfo.chargedah = '--'
          this.basicinfo.usedah = '--'
          this.basicinfo.warningAccount = '--'
          return
        }
        this.basicinfo.chargedah = res.resultModel.chargedAh
        this.basicinfo.usedah = res.resultModel.usedAh
        this.basicinfo.warningAccount = res.resultModel.warningCnt
      })
    },
    getOdcYhub (param) { // 表格中的饼状图和柱状图数据--yhub
      getOdc(param).then(res => { // Devices Summary
        if (res.resultCode === 1001) {
          var myRes = JSON.parse(JSON.stringify(res.resultModel))
          myRes.forEach((v, i) => {
            v.monthDay = getDateAndWeek(Number(v.monthDay), this.$store.state.language)
            v.pieSeriesData1 = []
            v.pieSeriesData1.push(
              { value: parseInt(v.chargeTime / 1000) || 0, name: i18n.t('yhubReport.ChargingTime'), divClass: 'myPieChartFirst' },
              { value: parseInt((86400 - v.usedTime / 1000 - v.chargeTime / 1000)) || 0, name: i18n.t('basicinfo.Idled'), divClass: 'myPieChartFirst' },
              { value: parseInt(v.usedTime / 1000) || 0, name: i18n.t('yhubReport.UseTime'), divClass: 'myPieChartFirst' }
            )
            v.pieSeriesData2 = []
            v.pieSeriesData2.push(
              { value: Math.round(v.charedAh / 100), name: i18n.t('QR.ChargedAH'), minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' },
              { value: Math.round(v.usedAh / 100), name: i18n.t('QR.dishargedAH'), minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' }
            )
          })
          this.devicesSummaryList1 = myRes
          getHourReport(param).then(response => {
            if (response.resultCode == 1001) {
              // 当两个数组长度不一致时，取短
              if (this.devicesSummaryList1.length > response.resultModel.length) {
                this.devicesSummaryList1 = this.devicesSummaryList1.splice(0, response.resultModel.length)
              } else if (this.devicesSummaryList1.length < response.resultModel.length) {
                response.resultModel = response.resultModel.splice(0, this.devicesSummaryList1.length)
              }
              this.devicesSummaryList1.forEach((m, mi) => {
                response.resultModel.forEach((v, vi) => {
                  this.devicesSummaryList1[mi].odcEventDailyVoList1 = JSON.parse(response.resultModel[mi].jsonStr)
                })
                m.maxTempratureS = temChange(Math.round(m.maxTemprature / 100))
              })
              this.devicesSummaryList = this.devicesSummaryList1
              this.$nextTick(() => {
                var arr = document.querySelectorAll('.questionPop')
                arr.forEach(v => {
                  v.style.display = 'none'
                })
              })
            }
          })
        }
      })
    },
    getOdcLithium (param) { // 表格中的饼状图和柱状图数据--lithium
      getOdcBMS(param).then(res => { // Devices Summary
        if (res.resultCode === 1001) {
          var myRes = JSON.parse(JSON.stringify(res.resultModel))
          myRes.forEach((v, i) => {
            v.monthDay = getDateAndWeek(Number(v.monthDay), this.$store.state.language)
            v.pieSeriesData1 = []
            v.pieSeriesData1.push(
              { value: parseInt(v.chargeTime / 1000) || 0, name: i18n.t('yhubReport.ChargingTime'), divClass: 'myPieChartFirst' },
              { value: parseInt((86400 - v.usedTime / 1000 - v.chargeTime / 1000)) || 0, name: i18n.t('basicinfo.Idled'), divClass: 'myPieChartFirst' },
              { value: parseInt(v.usedTime / 1000) || 0, name: i18n.t('yhubReport.UseTime'), divClass: 'myPieChartFirst' }
            )
            v.pieSeriesData2 = []
            v.pieSeriesData2.push(
              { value: Math.round(v.charedAh / 100), name: i18n.t('QR.ChargedAH'), minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' },
              { value: Math.round(v.usedAh / 100), name: i18n.t('QR.dishargedAH'), minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' }
            )
          })
          this.devicesSummaryList1 = myRes
          getHourReportBMS(param).then(response => {
            if (response.resultCode == 1001) {
              // 当两个数组长度不一致时，取短
              if (this.devicesSummaryList1.length > response.resultModel.length) {
                this.devicesSummaryList1 = this.devicesSummaryList1.splice(0, response.resultModel.length)
              } else if (this.devicesSummaryList1.length < response.resultModel.length) {
                response.resultModel = response.resultModel.splice(0, this.devicesSummaryList1.length)
              }
              this.devicesSummaryList1.forEach((m, mi) => {
                response.resultModel.forEach((v, vi) => {
                  this.devicesSummaryList1[mi].odcEventDailyVoList1 = JSON.parse(response.resultModel[mi].jsonStr)
                })
                m.maxTempratureS = temChange(Math.round(m.maxTemprature / 100))
              })
              this.devicesSummaryList = this.devicesSummaryList1
              this.$nextTick(() => {
                var arr = document.querySelectorAll('.questionPop')
                arr.forEach(v => {
                  v.style.display = 'none'
                })
              })
            }
          })
        }
      })
    },
    // 饼状图切换
    changePieChart (event, val, index) {
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
      }, 0)

      var eventParent = event.target.nodeName == 'SPAN' ? event.target.parentElement.parentElement : event.target.parentElement
      var eventDiv = document.getElementsByClassName('pieChartDiv')[index]
      if (val == 1) {
        eventDiv.firstChild.style.display = 'block'
        eventDiv.lastChild.style.display = 'none'
        eventParent.firstChild.classList.add('active')
        // eventParent.lastChild.classList.remove('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.remove('active')
      } else if (val == 2) {
        eventDiv.firstChild.style.display = 'none'
        eventDiv.lastChild.style.display = 'block'
        eventParent.firstChild.classList.remove('active')
        // eventParent.lastChild.classList.add('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.add('active')
      }
    },
    // 充放电柱状折线图----start
    initChart2 () { // 充放电记录
      var dom2 = document.getElementById('chart2')
      var myChart2 = echarts.init(dom2)
      myChart2.showLoading()
      this.dataSize = 0
      this.chargedAh = 0

      this.param = {
        endDate: this.weekReportEndTime,
        mcuId: this.$route.query.mcuId,
        startDate: this.weekReportStartTime
      }
      if (this.$route.query.type == 'Yhub') {
        this.listChargDisYhub(this.param, myChart2)
      } else if (this.type == 'Lithium') {
        this.listChargDisLithium(this.param, myChart2)
      }
    },
    listChargDisYhub (param, myChart2) { // 充放电柱状折线图组合数据--Yhub
      var n = []
      var chargeData = []
      var disChargeData = []
      var socData = []
      listChargingDischarging(param).then(response => {
        console.log('记录：', response)
        this.chargedRecordsList = JSON.parse(JSON.stringify(response.resultModel))
        this.chargedRecordArr = JSON.parse(JSON.stringify(response.resultModel))
        for (var i = this.chargedRecordsList.length - 1; i >= 0; i--) {
          var v = this.chargedRecordsList[i]
          if (!v.startWh || v.startWh < 0) v.startWh = 0
          if (!v.endWh || v.endWh < 0) v.endWh = 0
          v.wh = v.endWh - v.startWh > 0 ? handleFloat((v.endWh - v.startWh) / 1000) : 0
          v.startSoc = Math.round(v.startSoc) + '%'
          v.endSoc = Math.round(v.endSoc) + '%'
          v.startTemp = (v.startTemp || v.startTemp == 0) ? temChangeUnit(Math.round(v.startTemp / 100)) : '--'
          v.endTemp = (v.endTemp || v.endTemp == 0) ? temChangeUnit(Math.round(v.endTemp / 100)) : '--'
          v.avgTemp = (v.avgTemp || v.avgTemp == 0) ? temChangeUnit(Math.round(v.avgTemp / 100)) : '--'
          v.minVoltage = (v.minVoltage || v.minVoltage == 0) ? (v.minVoltage / 100).toFixed(2) + 'V' : '--'
          v.maxVoltage = (v.maxVoltage || v.maxVoltage == 0) ? (v.maxVoltage / 100).toFixed(2) + 'V' : '--'
          if (v.chargingType) {
            if (v.chargingType == 1) {
              v.chargingTypeZh = this.$t('yhubReport.FullCharge')
            } else if (v.chargingType == 2) {
              v.chargingTypeZh = this.$t('yhubReport.Intermediate')
            }// '满充'
            // case 2: v.chargingTypeZh = this.$t('yhubReport.Intermediate'); break// '临时充电'
            // default: v.chargingTypeZh = '--'; break
          }
          v.chargingTypeZh = '--'
          if (v.startTime && v.endTime) {
            var myTime = (new Date(v.endTime) - new Date(v.startTime))
            if (v.startTime) { v.startTimeRes = v.startTime; v.startTime = getDateAndHour(v.startTime, 'noYear') }
            if (v.endTime) { v.endTimeRes = v.endTime; v.endTime = getDateAndHour(v.endTime, 'noYear') }
            if ((v.startAh && v.endAh) || v.startAh == 0 || v.endAh == 0) v.energy = handleFloat(v.endAh - v.startAh)
            var days = parseInt(myTime / (1000 * 60 * 60 * 24))
            v.chargedTime = days > 0 ? days + ' d ' : ''
            v.chargedTime += parseInt((myTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((myTime % (1000 * 60 * 60)) / (1000 * 60)) + ' min '
          }

          // 动态合并单元格
          var cyclesIds = []
          this.chargedRecordsList.forEach((v, i) => {
            if (v.cycles) cyclesIds.push(v.cycles)
            v.num = 1
          })
          // console.log(cyclesIds)
          const cyclesObj = {}
          cyclesIds.forEach(key => {
            if (cyclesObj[key]) {
              cyclesObj[key]++
            } else {
              cyclesObj[key] = 1
            }
          })
          // console.log(cyclesObj)
          this.chargedRecordsList.forEach(element => {
            for (const key in cyclesObj) {
              if (Object.hasOwnProperty.call(cyclesObj, key)) {
                if (element.cycles == key) {
                  element.num = cyclesObj[key]
                }
              }
            }
          })
          // console.log(this.chargedRecordsList)
        }
        this.getFullChargeStatu() // 判断充放电记录表格中的满充和临时充电

        // 放电柱状图
        myChart2.hideLoading()
        const data = response.resultModel
        if (!data || (data && data.length < 1)) { this.columnLineNoData = true } else { this.columnLineNoData = false }
        // console.log('data-------------', data)
        for (const i in data) {
          var model = data[i]

          n.push(getDateAndHour(model.endTime, 'noYear'))
          socData.push(this.doubleToInt(model.endSoc))

          if (this.minSoc > model.endSoc) {
            this.minSoc = this.doubleToInt(model.endSoc)
          }
          if (model.isChargeing) {
            chargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })
            disChargeData.push('')
          } else {
            disChargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })
            chargeData.push('')
          }
        }
        var option2 = {
          tooltip: {
            trigger: 'axis',
            show: true,
            showDelay: 50,
            hideDelay: 50,
            transitionDuration: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            borderColor: '#f50',
            borderRadius: 10,
            borderWidth: 0,
            padding: 10,
            textStyle: {
              color: '#F9F7F7',
              decoration: 'none',
              fontFamily: 'Verdana, sans-serif',
              fontSize: 10,
              fontStyle: 'italic'
            }
          },
          legend: {
            data: [i18n.t('basicinfo.Charged'), i18n.t('basicinfo.DisCharged'), i18n.t('warningPage.SOC')],
            itemGap: 60
          },
          dataZoom: [
            {
              type: 'slider',
              show: true,
              start: 10,
              end: 90,
              handleSize: 8
            },
            {
              type: 'inside',
              start: 10,
              end: 90
            }
          ],
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: n,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: false,
                color: '#272456'
              },

              axisLabel: {
                formatter: '{value} Ah',
                color: '#59588D'
              }
            },
            {
              type: 'value',
              name: 'SOC',
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          color: ['#7fb80e', '#009ad6', '#A9F5F2'],
          series: [

            {
              name: i18n.t('basicinfo.Charged'),
              type: 'bar',
              barWidth: 20,
              data: chargeData,
              interval: 20,
              tooltip: {
                trigger: 'item'
              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: ['{a|{c}}'].join(''),
                  rich: {
                    a: {
                      color: '#7fb80e',
                      align: 'center'
                    }
                  }
                }
              }
            },
            {
              barGap: '-100%',
              name: i18n.t('basicinfo.DisCharged'),
              type: 'bar',
              barWidth: 20,
              interval: 20,
              data: disChargeData,
              tooltip: {
                trigger: 'item'
              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: ['{a|{c}}'].join(''),
                  rich: {
                    a: {
                      color: '#009ad6',
                      align: 'center'
                    }
                  }
                }
              }
            },
            {
              name: i18n.t('warningPage.SOC'),
              type: 'line',
              yAxisIndex: 1,
              data: socData,
              itemStyle: {
                normal: {
                  label: {
                    formatter: ['{a|{c}}'].join(''),
                    rich: {
                      a: {
                        color: '#0B3B39',
                        align: 'center',
                        testsize: 18
                      }
                    },
                    show: true,
                    position: 'left'
                  }
                }
              }
            }
          ]
        }
        if (option2 && typeof option2 === 'object') {
          myChart2.setOption(option2, true)
          myChart2.on('finished', function () { // 图表渲染完成后
            this.jlcgImgBase64 = myChart2.getDataURL()
            // document.getElementById('chart2').style.display = 'none'
            // document.getElementById('chart3').style.display = 'block'
            document.getElementById('chart3').setAttribute('src', this.jlcgImgBase64)
          })
        }
      })
    },
    listChargDisLithium (param, myChart2) { // 充放电柱状折线图组合数据--Lithium
      var n = []
      var chargeData = []
      var disChargeData = []
      var socData = []
      listChargingDischargingBMS(param).then(response => {
        this.chargedRecordsList = JSON.parse(JSON.stringify(response.resultModel))
        this.chargedRecordArr = JSON.parse(JSON.stringify(response.resultModel))
        for (var i = this.chargedRecordsList.length - 1; i >= 0; i--) {
          var v = this.chargedRecordsList[i]
          if (!v.startWh || v.startWh < 0) v.startWh = 0
          if (!v.endWh || v.endWh < 0) v.endWh = 0
          v.wh = v.endWh - v.startWh > 0 ? handleFloat((v.endWh - v.startWh) / 1000) : 0
          v.startSoc = Math.round(v.startSoc) + '%'
          v.endSoc = Math.round(v.endSoc) + '%'
          v.startTemp = (v.startTemp || v.startTemp == 0) ? temChangeUnit(Math.round(v.startTemp / 100)) : '--'
          v.endTemp = (v.endTemp || v.endTemp == 0) ? temChangeUnit(Math.round(v.endTemp / 100)) : '--'
          v.avgTemp = (v.avgTemp || v.avgTemp == 0) ? temChangeUnit(Math.round(v.avgTemp / 100)) : '--'
          v.minVoltage = (v.minVoltage || v.minVoltage == 0) ? (v.minVoltage / 100).toFixed(2) + 'V' : '--'
          v.maxVoltage = (v.maxVoltage || v.maxVoltage == 0) ? (v.maxVoltage / 100).toFixed(2) + 'V' : '--'
          // switch (v.chargingType) {
          //   case 1:v.chargingTypeZh = i18n.t('yhubReport.FullCharge'); break// '满充'
          //   case 2:v.chargingTypeZh = i18n.t('yhubReport.Intermediate'); break// '临时充电'
          //   default:v.chargingTypeZh = '--'; break
          // }

          if (v.startTime && v.endTime) {
            var myTime = (new Date(v.endTime) - new Date(v.startTime))
            if (v.startTime) { v.startTimeRes = v.startTime; v.startTime = getDateAndHour(v.startTime, 'noYear') }
            if (v.endTime) { v.endTimeRes = v.endTime; v.endTime = getDateAndHour(v.endTime, 'noYear') }
            if (v.startAh && v.endAh) v.energy = handleFloat(v.endAh - v.startAh)
            var days = parseInt(myTime / (1000 * 60 * 60 * 24))
            v.chargedTime = days > 0 ? days + ' d ' : ''
            v.chargedTime += parseInt((myTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((myTime % (1000 * 60 * 60)) / (1000 * 60)) + ' min '
          }
        }

        // 动态合并单元格
        var cyclesIds = []
        this.chargedRecordsList.forEach((v, i) => {
          if (v.cycles) cyclesIds.push(v.cycles)
          v.num = 1
        })
        // console.log(cyclesIds)
        const cyclesObj = {}
        cyclesIds.forEach(key => {
          if (cyclesObj[key]) {
            cyclesObj[key]++
          } else {
            cyclesObj[key] = 1
          }
        })
        // console.log(cyclesObj)
        this.chargedRecordsList.forEach(element => {
          for (const key in cyclesObj) {
            if (Object.hasOwnProperty.call(cyclesObj, key)) {
              if (element.cycles == key) {
                element.num = cyclesObj[key]
              }
            }
          }
        })

        this.getFullChargeStatu() // 判断充放电记录表格中的满充和临时充电

        // 放电柱状图
        myChart2.hideLoading()
        const data = response.resultModel
        if (!data || (data && data.length < 1)) { this.columnLineNoData = true } else { this.columnLineNoData = false }
        // console.log('data-------------', data)
        for (const i in data) {
          var model = data[i]

          n.push(getDateAndHour(model.endTime, 'noYear'))
          socData.push(this.doubleToInt(model.endSoc))

          if (this.minSoc > model.endSoc) {
            this.minSoc = this.doubleToInt(model.endSoc)
          }
          if (model.isChargeing) {
            chargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })
            disChargeData.push('')
          } else {
            disChargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })
            chargeData.push('')
          }
        }
        var option2 = {
          tooltip: {
            trigger: 'axis',
            show: true,
            showDelay: 50,
            hideDelay: 50,
            transitionDuration: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            borderColor: '#f50',
            borderRadius: 10,
            borderWidth: 0,
            padding: 10,
            textStyle: {
              color: '#F9F7F7',
              decoration: 'none',
              fontFamily: 'Verdana, sans-serif',
              fontSize: 10,
              fontStyle: 'italic'
            }
          },
          legend: {
            data: [i18n.t('basicinfo.Charged'), i18n.t('basicinfo.DisCharged'), 'SOC']
          },
          dataZoom: [
            {
              type: 'slider',
              show: true,
              start: 10,
              end: 90,
              handleSize: 8
            },
            {
              type: 'inside',
              start: 10,
              end: 90
            }
          ],
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: n,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: false,
                color: '#272456'
              },

              axisLabel: {
                formatter: '{value} Ah',
                color: '#59588D'
              }
            },
            {
              type: 'value',
              name: 'SOC',
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          color: ['#7fb80e', '#009ad6', '#A9F5F2'],
          series: [

            {
              name: i18n.t('basicinfo.Charged'),
              type: 'bar',
              barWidth: 20,
              data: chargeData,
              interval: 20,
              tooltip: {
                trigger: 'item'
              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: ['{a|{c}}'].join(''),
                  rich: {
                    a: {
                      color: '#7fb80e',
                      align: 'center'
                    }
                  }
                }
              }
            },
            {
              barGap: '-100%',
              name: i18n.t('basicinfo.DisCharged'),
              type: 'bar',
              barWidth: 20,
              interval: 20,
              data: disChargeData,
              tooltip: {
                trigger: 'item'
              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: ['{a|{c}}'].join(''),
                  rich: {
                    a: {
                      color: '#009ad6',
                      align: 'center'
                    }
                  }
                }
              }
            },
            {
              name: 'SOC',
              type: 'line',
              yAxisIndex: 1,
              data: socData,
              itemStyle: {
                normal: {
                  label: {
                    formatter: ['{a|{c}}'].join(''),
                    rich: {
                      a: {
                        color: '#0B3B39',
                        align: 'center',
                        testsize: 18
                      }
                    },
                    show: true,
                    position: 'left'
                  }
                }
              }
            }
          ]
        }
        if (option2 && typeof option2 === 'object') {
          myChart2.setOption(option2, true)
          myChart2.on('finished', function () { // 图表渲染完成后
            this.jlcgImgBase64 = myChart2.getDataURL()
            // document.getElementById('chart2').style.display = 'none'
            // document.getElementById('chart3').style.display = 'block'
            document.getElementById('chart3').setAttribute('src', this.jlcgImgBase64)
          })
        }
      })
    },
    getFullChargeStatu () { // 判断充放电记录表格中的满充和临时充电
      var fullChargeTime = this.basicinfo.fullChargeTime || 30
      if (this.chargedRecordsList.length > 0) {
        this.chargedRecordsList.forEach(v => {
          if (v.startTimeRes && v.endTimeRes) {
            v.myTime = (v.endTimeRes - v.startTimeRes) / (1000 * 60)
          } else if (!v.startTimeRes && v.startTime && v.endTime) {
            v.myTime = (v.endTime - v.startTime) / (1000 * 60)
          } else {
            v.myTime = 0
          }
          if (!v.isChargeing) { // 放电
            v.chargingTypeZh = '--'
          } else if ((v.endSoc == '100%' || (typeof (v.endSoc) === 'number' && Math.round(v.endSoc) == 100)) && v.isChargeing && v.myTime >= fullChargeTime) {
            v.chargingTypeZh = i18n.t('yhubReport.FullCharge') // '满充'
          } else {
            v.chargingTypeZh = i18n.t('yhubReport.Intermediate')// '临时充电'
          }
        })
      }
    },
    doubleToInt: function (d) {
      if (d !== null) {
        return Math.round(d)
      } else {
        return 0
      }
    },
    myFormat (params) {
      var str = ''
      const ah = thousandFn(parseFloat(params.endAh - params.startAh).toFixed(2)) || 0
      if (params.isChargeing) {
        str = '<h2>' + i18n.t('yhubReport.ChargedInfo') + '</h2>' +
          i18n.t('yhubReport.TotalAh') + ':\t' + ah + '\tAh' +
          '<br/>' + i18n.t('yhubReport.StartingTime') + ':\t' + getDateAndHour(params.startTime, 'noYear') + '\t\t' + parseFloat(params.startSoc).toFixed(0) + '\t %' +
          '<br/>' + i18n.t('yhubReport.EndTime') + ':\t' + getDateAndHour(params.endTime, 'noYear') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t %' +
          '<br/>' + i18n.t('yhubReport.MinTemp') + ':\t' + temChange(parseFloat(params.minTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MaxTemp') + ':\t' + temChange(parseFloat(params.maxTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MinVoltage') + ':\t' + params.minVoltage / 100 + '\tV' +
          '<br/>' + i18n.t('yhubReport.MaxVoltage') + ':\t' + params.maxVoltage / 100 + '\tV'
      } else {
        str = '<h2>' + i18n.t('yhubReport.DischargedInfo') + '</h2>' +
          i18n.t('yhubReport.TotalAh') + ':\t' + ah + '\tAh' +
          '<br/>' + i18n.t('yhubReport.DepthDischarge') + ':\t' + parseFloat(100 - params.endSoc).toFixed(0) + '\t%' +
          '<br/>' + i18n.t('yhubReport.EndTime') + ':\t' + getDateAndHour(params.endTime, 'noYear') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t%' +
          '<br/>' + i18n.t('yhubReport.MinTemp') + ':\t' + temChange(parseFloat(params.minTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MaxTemp') + ':\t' + temChange(parseFloat(params.maxTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MinVoltage') + ':\t' + params.minVoltage / 100 + '\tV' +
          '<br/>' + i18n.t('yhubReport.MaxVoltage') + ':\t' + params.maxVoltage / 100 + '\tV'
      }
      return str
    },
    formatter (row) {
      return row.rowIndex + 1
    },
    // 充放电柱状折线图----end
    rowIndex ({ row, rowIndex }) {
      row.rowIndex = rowIndex
    },
    // // 下载周报--pdf
    // downPDF() {
    //   this.isPrint = true
    //   // this.isShowLogo = true
    //   // document.getElementById('chart2').style.display = 'none'
    //   // document.getElementById('chart3').style.display = 'block'
    //   setTimeout(() => {
    //     var headHtml = "<head><style type='text/css' media='print'> @page{ size:  auto;   /* auto is the initial value */margin: 0mm;  /* this affects the margin in the printer settings */}html{/*background-color: #FFFFFF; */margin: 0px;  /* this affects the margin on the html before sending to printer */}</style></head><body>"
    //     var bottHtml = '<p style="height:30px;position:relative;float:right;right:20px;border-top:1px solid block;">' + 'Print Time：' + getDateAndHour(new Date().getTime(), 'noTime') + '</p></body>'
    //     var bdhtml = document.getElementById('mainContent').innerHTML // 获取当前页的html代码
    //     var prnhtml = headHtml + bdhtml + bottHtml // 从结束代码向前取html
    //     window.document.body.innerHTML = prnhtml
    //     window.print()
    //     window.document.body.innerHTML = bdhtml
    //     this.$router.go(0)
    //     this.isPrint = false
    //   }, 0)
    // },
    // 下载周报--pdf
    downPDF () {
      html2canvas(document.querySelector('#mainContent'), { allowTaint: true }).then(canvas => {
        const cw = canvas.width
        const ch = canvas.height
        const ph = cw / 592.28 * 841.89
        let lh = ch
        let ps = 0
        const imgw = 595.28
        const imgh = 592.28 / cw * ch
        const pdata = canvas.toDataURL('image/jpeg', 1.0)

        const pdf = new JsPDF('', 'pt', 'a4')
        if (lh < ph) {
          pdf.addImage(pdata, 'JPEG', 0, 0, imgw, imgh)
        } else {
          while (lh > 0) {
            pdf.addImage(pdata, 'JPEG', 0, ps, imgw, imgh)
            lh -= ph
            ps -= 841.89
            if (lh > 0) {
              pdf.addPage()
            }
          }
        }

        pdf.save('report.pdf')
      })
      return
      this.showTable = this.isPrint = true
      this.isShowLogo = true
      document.getElementById('chart2').style.display = 'none'
      document.getElementById('chart3').style.display = 'block'
      setTimeout(() => {
        // console.log('this.reportDetail.deviceSn===============', this.reportDetail.deviceSn)
        // // window.open('https://api.gpdcloud.net/v2/pdfTemplate?sn=' + this.reportDetail.deviceSn, '_self')
        // var body = document.body.innerHTML// 先获取当前页的html代码
        // var printHtml = document.getElementById('mainContent').innerHTML
        // document.body.innerHTML = printHtml// 需要打印的页面
        // window.print()
        // document.body.innerHTML = body// 打印完成之后，还原界面
        // this.$router.go(0)
        // this.showTable = false

        var headHtml = "<head><style type='text/css' media='print'> @page{ size:  auto;   /* auto is the initial value */margin: 0mm;  /* this affects the margin in the printer settings */}html{/*background-color: #FFFFFF; */margin: 0px;  /* this affects the margin on the html before sending to printer */}</style></head><body>"

        var bottHtml = '<p style="height:30px;position:relative;float:right;right:20px;border-top:1px solid block;">' + 'Print Time：' + getDateAndHour(new Date().getTime(), 'noTime') + '</p></body>'
        // if (oper < 10) {
        // pagesetup_null()
        var bdhtml = document.getElementById('mainContent').innerHTML // 获取当前页的html代码
        // sprnstr = "<!--startprint" + oper + "-->"; //设置打印开始区域
        // eprnstr = "<!--endprint" + oper + "-->"; //设置打印结束区域
        // var prnhtml = headHtml + bdhtml.substring(bdhtml.indexOf(sprnstr) + 18) // 从开始代码向后取html

        var prnhtml = headHtml + bdhtml + bottHtml // 从结束代码向前取html

        // var styleHtml =  " style = '' ";
        window.document.body.innerHTML = prnhtml
        window.print()
        window.document.body.innerHTML = bdhtml
        this.$router.go(0)
        this.showTable = this.isPrint = false
      }, 0)
    },
    queryLine () { // 弹窗--折线图
      var params = {
        // sn: this.popSn,
        startDate: new Date(this.popStartDate).getTime(),
        endDate: new Date(this.popEndDate).getTime() + 1000 * 60 * 60,
        mcuId: this.$route.query.mcuId
      }
      if (this.type == 'Yhub') {
        this.linePopDataYhub(params)
      } else {
        this.linePopDataLithium(params)
      }
    },
    linePopDataYhub (params) { // 弹窗折线图数据--Yhub
      listRecordData(params).then(res => { // 弹窗折线图数据
        this.loading = false
        var gnssProto
        const buf = protobuf.util.newBuffer(res)
        gnssProto = GNSSProto.decode(buf)
        const dataList = gnssProto.recordDatas ? gnssProto.recordDatas.recordData : []
        this.isShowNoData = !(dataList.length > 0)
        for (const i in this.yhubLineChartData) {
          this.yhubLineChartData[i] = []
        }
        var lastTime = null
        var dataSize = dataList.length
        for (const i in dataList) {
          var data = dataList[i]
          var time = dataList[i].time
          if (dataSize > 50000) {
            if (lastTime == null) {
              lastTime = time
            }
            if ((time - lastTime) / 1000 <= 10) {
              continue
            }
            lastTime = time
          }
          var ignition = data.ignitionVol / 100 > this.basicinfo.openIgnitionVol ? 1 : 0
          var hourMeter = data.hourMeterVol / 100 > this.basicinfo.workHourmeterVol ? 1 : 0
          this.yhubLineChartData.sn = this.basicinfo.deviceSn
          this.yhubLineChartData.d3.push([time, (data.ChargingCurrent / 100).toFixed(2)])
          this.yhubLineChartData.d4.push([time, (data.DisChargingCurrent / 100).toFixed(2)])
          this.yhubLineChartData.d5.push([time, (data.voltage / 100).toFixed(2)])
          this.yhubLineChartData.d6.push([time, (data.TotalChargedAh / 100).toFixed(2)])
          this.yhubLineChartData.d7.push([time, (data.TotalDisChargedAh / 100).toFixed(2)])
          this.yhubLineChartData.d8.push([time, (data.soc / 100).toFixed(0)])
          this.yhubLineChartData.d9.push([time, temChange((data.BatteryTemperature / 100).toFixed(0))])
          this.yhubLineChartData.d10.push([time, (data.chargingWh / 100000).toFixed(2)])
          this.yhubLineChartData.d11.push([time, (data.usingWh / 100000).toFixed(2)])
          this.yhubLineChartData.a1.push([time, ignition])
          this.yhubLineChartData.a2.push([time, hourMeter])
          this.yhubLineChartData.a3.push([time, (data.auxBatVol / 100).toFixed(2)])
          this.yhubLineChartData.a32.push([time, (data.voltage / 100 - data.auxBatVol / 100).toFixed(2)])
          if (data.auxCurrent > 0) { // 放电
            this.yhubLineChartData.a4.push([time, (data.auxCurrent / 10).toFixed(2)])
            this.yhubLineChartData.a5.push([time, 0])
          } else if (data.auxCurrent < 0) { // 充电
            this.yhubLineChartData.a4.push([time, 0])
            this.yhubLineChartData.a5.push([time, -(data.auxCurrent / 10).toFixed(2)])
          } else {
            this.yhubLineChartData.a4.push([time, 0])
            this.yhubLineChartData.a5.push([time, 0])
          }
          this.yhubLineChartData.a6.push([time, (data.auxSoc / 100).toFixed(2)])
          this.yhubLineChartData.a7.push([time, (data.socVolt / 100).toFixed(0)])
        }
      })
    },
    linePopDataLithium (params) { // 弹窗折线图数据--Lithium
      listBMSRecor(params).then(res => { // 弹窗折线图数据
        this.loading = false
        var gnssProto
        const buf = protobuf.util.newBuffer(res)
        gnssProto = GNSSProto.decode(buf)
        // if (!gnssProto.bmsRecord || (gnssProto.bmsRecord && gnssProto.bmsRecord.length < 1)) { this.nodata = true } else { this.nodata = false }
        if (gnssProto.bmsRecord != null && gnssProto.bmsRecord.bmsRecord != null) {
          var dataList = gnssProto.bmsRecord ? gnssProto.bmsRecord.bmsRecord : []
          this.isShowNoData = !(dataList.length > 0)
          this.nodata = !(dataList.length > 0)
          for (const i in this.lithiumLineChartData) {
            this.lithiumLineChartData[i] = []
          }
          console.log('dataList----', dataList)
          // ['Cha.(A)', 'Dis.(A)', 'Volt(V)', 'Cha.(Ah)', 'Dis.(Ah)', 'SOC(%)', 'Temp.(℃)']
          for (const i in dataList) {
            var data = dataList[i]
            var time = data.yhubTime
            var cur = data.current
            var vol = data.batteryVoltage
            var soc = data.soc > 100 ? Math.round(data.soc) : data.soc
            var temp1 = data.temperature ? data.temperature.split(',')[0] : 0
            var temp2 = data.temperature ? data.temperature.split(',')[1] : 0
            var usedah = data.usedAh
            var chargedah = data.chargingAh
            if (cur < 0) {
              this.lithiumLineChartData.d3.push([time, (cur * -1 / 100).toFixed(2)])
              this.lithiumLineChartData.d4.push([time, (0 / 100).toFixed(2)])
            } else {
              this.lithiumLineChartData.d3.push([time, (0 / 100).toFixed(2)])
              this.lithiumLineChartData.d4.push([time, (cur / 100).toFixed(2)])
            }
            this.lithiumLineChartData.sn = this.basicinfo.deviceSn
            this.lithiumLineChartData.d5.push([time, (vol / 100).toFixed(2)])
            this.lithiumLineChartData.d6.push([time, (chargedah / 100).toFixed(2)])
            this.lithiumLineChartData.d7.push([time, (usedah / 100).toFixed(2)])
            this.lithiumLineChartData.d8.push([time, (soc / 100).toFixed(0)])
            this.lithiumLineChartData.d9.push([time, temChange(temp1)])
            this.lithiumLineChartData.d10.push([time, (data.chargingWh / 100000).toFixed(2)])
            this.lithiumLineChartData.d11.push([time, (data.usingWh / 100000).toFixed(2)])
          }
        }
      })
    },
    readMore (item) { // 弹窗--显示
      if (item != null) {
        this.popStartDate = item.startTimeRes
        this.popEndDate = item.endTimeRes
      } else {
        this.popStartDate = this.weekReportStartTime
        this.popEndDate = this.weekReportEndTime
      }
      this.queryLine()
      this.isShowPop = this.loading = true
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
      }, 0)
    },
    closePop () { // 弹窗--关闭
      this.isShowPop = false
    },
    changeSearch () { // 弹窗--时间选择
      this.queryLine()
    },
    change () {
      this.$forceUpdate()
    },
    submitPop () { // Download Raw CSV--下载
      this.isShowLoadingPop = true
      this.isShowRegionPop = false
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.$route.query.sn,
        mcuId: this.$route.query.mcuId,
        startDate: new Date(this.popStartDate).getTime(),
        endDate: new Date(this.popEndDate).getTime()
      }
      var timeZ = new Date().getTimezoneOffset() / 60
      this.isShowLoadingPop = true
      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      // console.log(param)
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      var url = ''
      if (this.type == 'Yhub') {
        url = process.env.VUE_APP_BASE_API + '/v3/report/exportRecordDataCsv'
        url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + param.sn + '&columns=' + this.legendselectStr + '&timeZone=' + paramTimeZ + '&regionType=' + this.regionType
      } else if (this.type == 'Lithium') {
        url = process.env.VUE_APP_BASE_API + '/v3/canbus/bmsRecord/exportBMSDataCsv'
        url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + param.sn + '&timeZone=' + paramTimeZ + '&regionType=' + this.regionType + '&tem=' + tem
      }
      console.log(url)
      window.open(url, '_bank')
    },
    downLoadExcel () { // Download Raw CSV--打开选中数字分割选项的弹窗
      this.isShowRegionPop = true
    },
    legendselect (str) {
      this.legendselectStr = str
    },
    downLoadReportExcel () {
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.$route.query.sn,
        mcuId: this.$route.query.mcuId,
        startDate: parseInt(new Date(this.popStartDate).getTime()),
        endDate: parseInt(new Date(this.popEndDate).getTime())
      }
      var timeZ = new Date().getTimezoneOffset() / 60
      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      var tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/getcsv?sn='
      // url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + this.listQuery.sn
      url += param.sn + '&startTime=' + param.startDate + '&endTime=' + param.endDate + '&timeZone=' + paramTimeZ + '&tem=' + tem
      window.open(url, '_bank')
    },
    changeSearchWeekReport () { // 日期选择器
      // console.log(this.selectDayWeekReport)
      if (this.selectDayWeekReport) { // 选择了时间
        this.weekReportStartTime = new Date(this.selectDayWeekReport[0]).getTime()
        this.weekReportEndTime = new Date(this.selectDayWeekReport[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      } else {
        this.weekReportEndTime = this.$route.query.latest ? this.upadateLast : this.todayLast
        this.weekReportStartTime = this.$route.query.latest ? (this.upadateLast - 1000 * 60 * 60 * 24 * 7 + 1000) : (this.todayLast - 7 * 24 * 60 * 60 * 1000 + 1000)
      }
      // alert(this.weekReportStartTime + "," + this.weekReportEndTime);
      // TODO
      this.queryList()
      this.queryWarnings()
      setTimeout(() => {
        this.initChart2()
      }, 500)

      this.basicinfo.startTime = getDateAndHour(this.weekReportStartTime, 'noTime')
      this.basicinfo.endTime = getDateAndHour(this.weekReportEndTime, 'noTime')

      this.showDynamicData()
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end

  }
}
</script>

<style lang="scss" scoped>
@media print {
  html,
  body {
    //A4默认为210mm*287mm
    width: 210mm;
    height: 297mm;
  }
  .page {
    font-size: 10pt;
    width: initial;
  }
  .page .part2 td {
    height: 1cm;
  }
}

.columnTable tr:nth-of-type(even) {
  background: #f0f2f5a3;
}
.questionPop,
.dischargePop,
.WorkTimeWarp,
.usedTimeWarp {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  // margin: -120px 0 0 160px;
  left: 120px;
  bottom: 40px;
  max-width: 100%;
}
.questionPop {
  width: 100%;
}
.dischargePop {
  margin: 0;
  width: auto;
  bottom: auto;
  left: 50%;
  top: 25px;
  transform: translate(-50%, 0);
}
.WorkTimeWarp,
.usedTimeWarp {
  margin: 0;
  left: 10%;
  width: auto;
  bottom: auto;
  top: -50px;
}
.usedTimeWarp {
  left: 15%;
}
.yhubHeader {
  background: white;
  height: 108px;
  margin: 0 !important;
  // margin-right:0!important;
}
.yhubHeaderP {
  display: inline-block;
  width: 100%;
  line-height: 108px;
  font-size: 20px;
  font-weight: bold;
  position: relative;
  padding-left: 20px;
}
.yhubHeaderP span {
  font-size: 16px;
  line-height: 16px;
  font-weight: normal;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.blockTitleP {
  font-size: 16px;
  color: #000;
  line-height: 16px;
  font-weight: bold;
  padding: 20px 0;
}
.warningP {
  background: #ffffcc;
  line-height: 40px;
  border: 1px solid #ffcc99;
  border-radius: 5px;
  padding-left: 10px;
  margin: 5px 0;
}
.changePieBtn {
  outline: none; //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #c2e7b0;
  background: #f0f9eb;
  margin-bottom: 10px;
  position: relative;
}
.changePieBtn:nth-of-type(1) {
  // margin-right:10px;
  margin-left: calc(1% + 5px);
}
.active {
  border: 1px solid #67c23a;
  background: #67c23a;
  color: white;
}
.downBtn {
  height: 35px;
  line-height: 35px;
  background: #1990fc;
  display: inline-block;
  border-radius: 4px;
  padding: 0 10px;
  color: white;
  position: absolute;
  right: 20px;
  cursor: pointer;
}
.popWrap {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 2;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popContent {
  background: white;
  width: 80%;
  height: 80%;
  padding: 20px;
}
#mainContent .el-dialog {
  margin-top: 10vh !important;
}
.weekReportHead {
  /* margin-bottom: 20px; */
  display: flex;
  padding: 0 20px;
  flex-wrap: nowrap;
}
.headBr {
  width: 50%;
  height: 1px;
  border-top: 1px solid black;
}
.headContent {
  flex-shrink: 0;
  padding: 0 30px;
  text-align: center;
  line-height: 30px;
}
.headContent span {
  font-size: 20px;
  font-weight: bold;
}
.fontStyle2 {
  margin: 0 5px 0 25px !important;
  width: 10px;
  height: 10px !important;
  display: inline-block;
  background: #019ad6;
  border-radius: 50%;
}
.headInfo {
  height: auto;
  padding-bottom: 15px;
}
.noDataDiv {
  height: 50px;
  border: 1px solid #eeeeee;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: none;
  color: #606266;
  font-size: 14px;
}
.noDataWarp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.regionP {
  margin: 10px;
  font-weight: bold;
  display: inline-block;
}
.regionPop .el-radio {
  margin-left: 10px;
}
</style>
